const formatMessage = (text) => {
    // Split text into paragraphs
    const paragraphs = text.split('\n').filter(p => p.trim());

    // Process each paragraph for bold text and other formatting
    return paragraphs.map(paragraph => {
        // Handle bold text (wrapped in ** or *)
        paragraph = paragraph.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        paragraph = paragraph.replace(/\*(.*?)\*/g, '<strong>$1</strong>');

        // Remove source referencing
        paragraph = paragraph.replace(/【[^】]*】/g, '');

        // Handle lists
        if (paragraph.startsWith('- ')) {
            return `<li>${paragraph.slice(2)}</li>`;
        }

        return `<p>${paragraph}</p>`;
    });
};

export default formatMessage